import '@fontsource-variable/inter';
import '@pv-frontend/ui-components-web/css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import {
    PublicClientApplication,
    EventType,
    type AuthenticationResult,
} from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { readEnv } from './env';
import { buildMsalConfig } from './auth/msal-config';
import { App } from './app';

const env = readEnv();
const msalInstance = new PublicClientApplication(buildMsalConfig(env));

async function bootstrap() {
    // MSAL v3+ requires explicit initialization before any other API call.
    await msalInstance.initialize();

    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
    }

    // Keep the active account in sync after an interactive login redirect.
    msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            const result = event.payload as AuthenticationResult;
            if (result.account) msalInstance.setActiveAccount(result.account);
        }
    });

    const container = document.getElementById('root');
    if (!container) throw new Error('Root element #root not found');

    createRoot(container).render(
        <StrictMode>
            <MsalProvider instance={msalInstance}>
                <App />
            </MsalProvider>
        </StrictMode>,
    );
}

void bootstrap();
